import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-icon',
  template: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      @switch (key) {
        @case ('instagram') {
          <rect x="3" y="3" width="18" height="18" rx="5"></rect>
          <circle cx="12" cy="12" r="4"></circle>
          <circle class="fill" cx="17.5" cy="6.5" r="1.1"></circle>
        }
        @case ('facebook') {
          <path class="fill" d="M14 8h3V4.3c-.5-.1-2-.3-3.8-.3C9.7 4 8 6 8 9.5V12H5v4h3v8h4v-8h3.3l.7-4H12V9.9C12 8.7 12.4 8 14 8Z"></path>
        }
        @case ('x') {
          <path d="m5 4 14 16M19 4 5 20"></path>
        }
        @case ('youtube') {
          <rect x="2.5" y="6" width="19" height="12" rx="4"></rect>
          <path class="fill" d="m10 9 5 3-5 3Z"></path>
        }
        @case ('whatsapp') {
          <path d="M20 11.5a8 8 0 0 1-11.8 7L4 20l1.4-4A8 8 0 1 1 20 11.5Z"></path>
          <path d="M9 8.2c.4 2.8 2 4.4 4.8 4.8l1.2-1.2 2 1c-.5 1.8-1.5 2.7-3 2.5-4.5-.5-7-3-7.5-7.5C6.3 6.3 7.2 5.3 9 5l1 2-1 1.2Z"></path>
        }
        @case ('linkedin') {
          <rect class="fill" x="4" y="9" width="3" height="11"></rect>
          <circle class="fill" cx="5.5" cy="5.5" r="1.8"></circle>
          <path d="M11 20V9m0 5c0-3 7-4 7 1v5"></path>
        }
        @case ('tiktok') {
          <path d="M14 4v11a4 4 0 1 1-4-4m4-7c.7 3 2.3 4.4 5 4.5"></path>
        }
        @case ('phone') {
          <path d="M7 3 4 5c1 7 6 12 13 15l3-3-4-4-2 2c-2.5-1.3-4.7-3.5-6-6l2-2-3-4Z"></path>
        }
        @case ('email') {
          <rect x="3" y="5" width="18" height="14" rx="2"></rect>
          <path d="m4 7 8 6 8-6"></path>
        }
        @case ('googlemaps') {
          <path d="M12 22s7-7 7-13A7 7 0 0 0 5 9c0 6 7 13 7 13Z"></path>
          <circle cx="12" cy="9" r="2.5"></circle>
        }
        @default {
          <path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1"></path>
        }
      }
    </svg>
  `,
  styles: [`
    :host{display:inline-grid;height:1.2em;place-items:center;width:1.2em}
    svg{fill:none;height:100%;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8;width:100%}
    .fill{fill:currentColor;stroke:none}
  `]
})
export class SocialIconComponent {
  @Input({ required: true }) platform = '';
  protected get key(): string {
    return this.platform.toLowerCase().replace(/[^a-z]/g, '');
  }
}
